module.exports = __webpack_public_path__ + "assets/icons/baseline-alarm_add-24px-c360.svg";